<template>
    <div id="company">
        <el-row style="border-bottom:2px dotted #e7eaec;padding-bottom: 10px;">
            <el-col :span="20" style="font-weight: bold;line-height: 36px;font-size: 22px">
                公司通知
            </el-col>
            <el-col :span="4" >
                <el-button type="success" @click.stop="handleAddClick" style="float: right" size="small">
                    <i :class="['iconfont', 'el-icon-plus']" style="position: relative;top:1px"></i>
                    新增
                </el-button>
            </el-col>
        </el-row>

        <el-row style="margin-top:20px;border-bottom: 2px dotted rgb(231, 234, 236)">
            <el-row>
                <el-col :span="12">
                                <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                    日期</span>
                    <div style="display: inline-block;width: calc(100% - 120px);">
                        <el-date-picker
                                v-model="start_time"
                                format="yyyy-M-d"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期"
                                style="width:45%">
                        </el-date-picker><span style="display: inline-block;width: 10%;text-align: center">至
                                </span><el-date-picker
                            v-model="end_time"
                            format="yyyy-M-d"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期"
                            style="width:45%">
                    </el-date-picker>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="margin-top: 20px">
                            <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                标题</span>
                    <el-input v-model="title" placeholder="请输入标题"
                              style="width:calc(100% - 120px)"></el-input>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" style="margin-top: 20px">
                            <span style="font-weight: bold;display: inline-block;width: 70px;margin-right: 10px">
                                状态</span>

                    <el-checkbox-group style="display: inline-block;width:calc(100% - 120px);" v-model="radio" @change="ladderChange">
                        <el-checkbox  label="unsend">未发送</el-checkbox>
                        <el-checkbox  label="sended">已发送</el-checkbox>
                    </el-checkbox-group>
                </el-col>


            </el-row>
            <el-row style="margin-bottom:20px;margin-top: 84px">
                <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
                <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
            </el-row>
        </el-row>

        <el-table
                :data="tableData"
                :header-cell-style="{'color':'black','font-size':'15px'}"
                border
                style="width: 100%;margin-top: 20px"
                stripe>
            <el-table-column
                    fixed
                    align="center"
                    type="index"
                    label="序号"
                    width="60">
            </el-table-column>
            <el-table-column
                    min-width="400"
                    prop="title"
                    sortable
                    label="标题">
            </el-table-column>
            <el-table-column
                    width="200"
                    prop="sent_date"
                    sortable
                    label="发送日期">
                <template slot-scope="scope">
                <span v-if="scope.row.sent_date">
                    {{scope.row.sent_date}}
                </span>
                <span v-else>
                    -
                </span>
            </template>

            </el-table-column>

            <el-table-column
                    fixed="right" label="操作"
                    width="80"
                    style="color: #3b99f7"
                    label-class-name="company_table_cell"
            >
                <template slot-scope="scope">
                    <el-button
                            size="small" style="float: right;background: #FF9901;border:none;color: #fff"
                            @click="handleDetail(scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-col style="margin-bottom: 20px">
            <pagination :page="page" @changePage="changePageClick"></pagination>
        </el-col>

        <el-dialog
                :visible.sync="dialogVisit"
                width="70%"
                :show-close="false"
                :before-close="handleClose"
                style="vertical-align: center;color: #FFF9F3;">
            <div style="height: 800px">
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 15px;">
                    <el-col :span="6">
                        <div style="color: #3998F7;font-size: 20px;">公司通知
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <div align="right">
                            <p style="margin: 0;display: inline-block;color:#999999;margin-right: 40px;">最后发送日期：{{date}}</p>
                            <el-button size="small" style="background: #FF9901;border:1px solid #FF9901;color: #fff" icon="el-icon-s-promotion" @click.stop="send">
                                发送
                            </el-button>
                            <el-button type="primary" size="small" @click.stop="add">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="back" style="margin-top: 20px;">
                    <el-form ref="formList" :model="companyNoticeList" label-width="10%" hide-required-asterisk>
                        <el-row style="margin: 0 auto;width: 95%">
                            <el-col>
                                <el-form-item label="标题" class="home_star" prop="title" :rules="[
                                           { required: true, message: '标题不能为空'},
                                    ]">
                                    <el-input v-model="companyNoticeList.title" placeholder="请输入标题"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="内容" class="home_star" prop="content" :rules="[
                                           { required: true, message: '内容不能为空'},
                                    ]">
                                    <div>
                                        <div id="toolbar" slot="toolbar">
                                            <button class="ql-bold" title="加粗">Bold</button>
                                            <button style="width: auto">
                                                <select class="ql-header" title="段落格式">
                                                    <option selected>正文</option>
                                                    <option value="2">标题1</option>
                                                    <option value="3">标题2</option>
                                                    <option value="4">标题3</option>
                                                </select>
                                            </button>

                                            <button class="ql-list" value="ordered" title="有序列表"></button>
                                            <button class="ql-list" value="bullet" title="无序列表"></button>
                                            <button style="width: auto;">
                                                <select class="ql-color" value="color" title="字体颜色"></select>
                                            </button>


                                            <button class="icon-pic custom-icon " title="图片" style="font-size: 18px" @click="insertImgClick($event)">
                                                <i class="el-icon-picture-outline" style="color: #444444"></i>
                                            </button>  <!-- 插入图片 -->
                                            <button class="icon-video custom-icon " title="视频" style="font-size: 18px" @click="insertImgClick($event)">
                                                <i class="el-icon-film" style="color: #444444"></i>
                                            </button>  <!-- 插入视频 -->
                                        </div>
                                        <input style="display: none;" type="file" id="insert_image" @change="fileInsert($event)">  <!-- 选择图片input -->
                                        <input style="display: none;" type="file" id="insert_video" @change="fileInsert($event)">  <!-- 选择视频input -->
                                    </div>


                                    <quill-editor
                                            v-model="companyNoticeList.content"
                                            ref="myQuillEditor"
                                            :options="editorOption"
                                            @focus="onEditorFocus($event)"
                                            @blur="onEditorBlur($event)"
                                            @change="onEditorChange($event)">
                                    </quill-editor>

<!--                                    <quill-editor ref="myQuillEditor"  v-model="companyNoticeList.content" style="height:400px;" class="myQuillEditor"-->
<!--                                                  :options="editorOption"-->

<!--                                                  />-->


<!--                                    <Editorbar v-model="companyNoticeList.content" :isClear="isClear" @change="changeEditor1"></Editorbar>-->

                                </el-form-item>
                            </el-col>
                        </el-row>

                    </el-form>
                </div>
            </div>

        </el-dialog>




    </div>
</template>

<script>
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import moment from 'moment'



    import { quillEditor } from 'vue-quill-editor'
    // import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    // import 'quill/dist/quill.bubble.css'
    import * as Quill from 'quill' //引入编辑器
    // import { ImageDrop } from 'quill-image-drop-module';
    // Quill.register('modules/imageDrop', ImageDrop);
    // import ImageResize from 'quill-image-resize-module'  //调整大小
    // Quill.register('modules/imageResize', ImageResize)  //添加

    import http2 from "../../../APIService/http2";
    import Video from './video.js'
    Quill.register(Video, true);


    export default {
        name: "companyNotice",
        data(){
            var self = this;
            return{
                editor: null,   // 富文本编辑器对象

                editorOption: { //  富文本编辑器配置
                    modules: {
                        toolbar: '#toolbar'
                    },
                    theme: 'snow',
                    placeholder: '请输入正文'
                },
                videoUploadTag:false,
                imageFileList:[],
                activeName:"first",
                videoLink:"",
                start_time:'',
                end_time:'',
                title:'',
                radio:[],
                tableData:[],
                notice_id:'',
                page:{
                    current: 1,
                    size: 5,
                    total: 0
                },
                dialogVisit:false,
                companyNoticeList:{
                    title:'',
                    content:'',
                },
                // editorOption:quillConfig,
                noticeList:[],
                isClear:false,
                date:'',
                uuid:'',
                sfileType:'',
                picture_id:'',
                video_id:'',
                img_index:0,
                vid_index:0,
                getImg_index:0,
                getImg:'',
                getVid_index:0,
                getVid:'',
                newArr:[],
                contentList:[],
                collectionList:[]

            }
        },
        components: {
            pagination,
            quillEditor,
            // Editorbar
        },
        created() {

        },
        mounted() {
            this.init()


        },
        methods:{
// 准备富文本编辑器
            onEditorReady (editor) {},
// 富文本编辑器 失去焦点事件
            onEditorBlur (editor) {},
// 富文本编辑器 获得焦点事件
            onEditorFocus (editor) {},
// 富文本编辑器 内容改变事件
            onEditorChange (editor) {},
// 富文本编辑器 点击插入图片或者视频
            insertImgClick (e) {
                console.log(e)
                if (e.target.className.indexOf('el-icon-picture-outline') != -1) {
                    document.getElementById('insert_image').click();
                } else if (e.target.className.indexOf('el-icon-film') != -1) {
                    document.getElementById('insert_video').click();
                }
            },

            getUuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                this.uuid = uuid

            },
            fileInsert (e) {
                console.log(e)
                this.getUuid()

                var oFile = e.target.files[0];
                if (typeof (oFile) === 'undefined') {
                    return;
                }
                let sExtensionName = oFile.name.substring(oFile.name.lastIndexOf('.') + 1).toLowerCase();   // 文件扩展名
                 this.sfileType = ''; // 上传文件类型
                  this.sfileType1 = ''; // 上传文件类型
                if (e.target.id == 'insert_image') {
                    this.sfileType = 'PICTURE'
                    this.sfileType1 = 'image'
                    if (sExtensionName !== 'png' && sExtensionName !== 'jpg' && sExtensionName !== 'jpeg') {
                        alert('不支持该类型图片');
                        return;
                    }
                }
                if (e.target.id == 'insert_video') {
                    this.sfileType = 'VIDEO';
                    this.sfileType1 = 'video'
                    if (sExtensionName !== 'mp4' && sExtensionName !== 'avi' && sExtensionName !== 'mov') {
                        alert('不支持该类型视频');
                        return;
                    }
                    let maxSize = 100*1024*1024;    // 100MB
                    if (oFile.size > maxSize) {
                        alert('上传视频大小不能超过100MB');
                        return;
                    }
                }
                var reader = new FileReader();
                reader.readAsDataURL(oFile);
                reader.onloadend = () => {
                    // formData.append('file', this.file);
                    let formData = new FormData();

                    formData.append('file', oFile);
                    formData.append('reference_obj', 'CLIENT');
                    formData.append('reference_id', 'com.saasyun.android');
                    formData.append('credential','0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4');
                    formData.append('tenant_id', this.$store.getters.getUser.tenant_id);
                    formData.append('username', this.$store.getters.getUser.username);
                    formData.append('user_id', this.$store.getters.getUser.user_id);
                    formData.append('event_obj', 'NOTICES');
                    formData.append('event_id', this.uuid);
                    formData.append('category', 'LIBRARY');
                    let config = {
                        headers:{'Content-Type':'multipart/form-data'}
                    };

                    http.post("/files/uploadfile?tenant_id="
                        + this.$store.getters.getUser.tenant_id+"&reference_id=com.saasyun.android&user_id='"+this.$store.getters.getUser.user_id+"'",formData,config).then((res) => {
                        console.log(res.data)
                            this.piclist(res.data)



                    }).catch((response) => {
                        console.log('失败', response);
                    })
                }
            },
            async piclist(list) {
                try {


                    let obj5 = {
                        file_id: list.s3filename,
                        file_name: list.filename,
                        file_type: list.filetype,
                        file_size: list.filesize,
                        extension:list.filename.split(".")[1]
                    }

                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,//必填
                        user_id: this.$store.getters.getUser.user_id,//必填
                        notice_id:this.uuid,
                        category:this.sfileType,
                        fileInfo: obj5
                    }
                    await http2.post("/wapi/dataBank/addNoticeFile", data).then(res => {
                        console.log(res)
                        if (res.success) {
                            console.log(res)
                            if (obj5.extension == 'png' || obj5.extension == 'jpg' || obj5.extension == 'jpeg') {
                               this.picture_id = obj5.file_id
                                this.getImgUrl(this.picture_id,'image')
                            }else if(obj5.extension == 'mp4'){
                                this.video_id = obj5.file_id
                                this.getImgUrl(this.video_id,'video')
                            }
                        }
                    })
                } catch (err) {
                    this.error()
                }
            },




            async getImgUrl(file_id,type) {
                try {

                    console.log(file_id)
                    let url = ''

                    let Body = new FormData()
                    Body.append('credential', '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4')
                    Body.append('file_ids', file_id)
                    Body.append('tenant_id', this.$store.getters.getUser.tenant_id)
                    Body.append('reference_obj', 'CLIENT')
                    Body.append('reference_id', 'com.saasyun.android')


                    let config = {
                        headers:{'Content-Type':'multipart/form-data'}
                    };


                await http.post('/files/downloadfiles',Body,config)//
                        .then(response => {


                            if (response.success) {

                                url = response.data[0].url

                                this.contentList.push(
                                    {
                                        file_id:file_id,
                                        type:type
                                    }
                                )



                                this.editor = this.$refs.myQuillEditor.quill;


                                let length = this.editor.selection.savedRange.index;
                                this.editor.insertEmbed(length, this.sfileType1, url);  // 这个方法用来手动插入dom到编辑器里

                                this.editor.setSelection(length + 1);  // 这个方法可以获取光标位置
                                console.log(this.sfileType1,url,this.companyNoticeList.content)

                            }
                        })


                } catch (err) {


//                    this.error()
                }
            },


            changeEditor1 (res) {
                console.log(res)        // 这个res就是实时输入的富文本的内容，打印出来是实时输入的字符串html
            },
            ladderChange(){
                if (this.radio.length>1){
                    this.radio.shift()
                }
            },

            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        title:this.title,
                        radio:this.radio
                    }
                    if (this.start_time == '' || this.start_time == null){
                        data.start_time = ''
                    } else {
                        data.start_time=moment(this.start_time).format('YYYY-MM-DD')
                    }
                    if (this.end_time == '' || this.end_time == null){
                        data.end_time = ''
                    } else {
                        data.end_time=moment(this.end_time).format('YYYY-MM-DD')
                    }

                    await http.post('/wapi/notice/getNoticeList',data).then(res=>{

                        if(res.success){
                            this.tableData = res.data.result
                            this.page.total = res.data.arrayCount

                        }
                        loading.close()
                    })

                }catch (e) {
                    loading.close()
                    return e
                }
            },
            handleAddClick(){
                this.dialogVisit = true
                this.contentList=[]
                this.notice_id = ''
                this.companyNoticeList={
                    title:'',
                    content:''
                }
                this.date = ''
                this.$refs['formList'].resetFields()

            },
            handleQueryClick(){
                console.log(this.$refs,this.$refs.myQuillEditor)
                this.init()
            },
            handleResetClick(){
                this.start_time=""
                this.end_time=""
                this.title=""
                this.radio=[]
            },
            handleDetail(item){
                console.log(item)
                this.companyNoticeList={
                    title:item.title,
                    content:'',
                }
                this.contentList = []
                this.notice_id =  item.notice_id
                this.date = item.sent_date


                // this.newArr = item.contents.split('|&')

                this.collectionList=[]

                this.getNextUrl(-1,this.collectionList,item.contents);















            },

            getNextUrl(index, arrayList,contents) {


                var start_index;
                if(index == -1){
                    start_index=contents.indexOf("|&");
                }else {
                    start_index = index;
                }
                var end_index=contents.indexOf("|&", start_index+1);
                var result=contents.substring(start_index+2,end_index);

                var obj={
                    file_type:'',
                    file_id:'',
                    url:''
                }


                if(result.indexOf("picture_id") !== -1){
                    obj.file_type="picture_id";
                    obj.file_id=JSON.parse(result).picture_id;
                }
                if(result.indexOf("video_id") !== -1){
                    obj.file_type="video_id";
                    obj.file_id=JSON.parse(result).video_id;
                }


                let type = ''
                if(obj.file_type == 'picture_id'){
                    type = 'image'
                }else if(obj.file_type == 'video_id'){
                    type = 'video'
                }
                this.contentList.push(
                    {
                        file_id:obj.file_id,
                        type:type
                    }
                )


                let url = ''

                let Body = new FormData()
                Body.append('credential', '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4')
                Body.append('file_ids', obj.file_id)
                Body.append('tenant_id', this.$store.getters.getUser.tenant_id)
                Body.append('reference_obj', 'CLIENT')
                Body.append('reference_id', 'com.saasyun.android')


                let config = {
                    headers:{'Content-Type':'multipart/form-data'}
                };


                http.post('/files/downloadfiles',Body,config).then(response => {


                    if (response.success) {

                        if(response.data.length>0){
                            url = response.data[0].url

                            if(obj.file_type == 'picture_id'){
                                obj.url = '<img src='+url+' alt="picvision" style="margin-top:10px;max-width:100%;">'

                            }else if(obj.file_type == 'video_id'){
                                obj.url = '<video controls="controls" poster="" src='+url+' height="300" style="margin-top:10px;max-width:100%;">'

                            }
                            arrayList.push(obj);
                            if(contents.indexOf("|&",end_index+1) != -1){
                                var ind=contents.indexOf("|&", end_index+1);
                                this.getNextUrl(ind,arrayList,contents);
                            }else{
                                this.replaceUrl(arrayList,contents)
                            }
                        }else{
                            this.companyNoticeList.content=contents
                            this.dialogVisit = true
                        }




                    }
                })


                // this.getLabel(obj,contents)



            },

            replaceUrl(arr,contents){

                let str = ''
                for(let i =0;i<arr.length;i++){
                    if(arr[i].file_type == 'picture_id'){
                        var oldStr = "|&{"+"\"picture_id\""+":\""+arr[i].file_id+"\"}|&";
                        var newStr = arr[i].url
                        str = contents.replace(oldStr,newStr)
                        contents = str
                    }else if(arr[i].file_type == 'video_id'){
                        var oldStr = "|&{"+"\"video_id\""+":\""+arr[i].file_id+"\"}|&";
                        var newStr = arr[i].url
                        str = contents.replace(oldStr,newStr)
                        contents = str
                    }
                }
                this.companyNoticeList.content=str
                this.dialogVisit = true
            },


             getLabel(obj,contents){
                         try {

                             let url = ''

                             let Body = new FormData()
                             Body.append('credential', '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4')
                             Body.append('file_ids', obj.file_id)
                             Body.append('tenant_id', this.$store.getters.getUser.tenant_id)
                             Body.append('reference_obj', 'CLIENT')
                             Body.append('reference_id', 'com.saasyun.android')


                             let config = {
                                 headers:{'Content-Type':'multipart/form-data'}
                             };


                             http.post('/files/downloadfiles',Body,config).then(response => {


                                     if (response.success) {
                                         url = response.data[0].url
                                         console.log(url)

                                         if(obj.type == 'picture_id'){
                                             obj.url = '<img src='+url+' alt="picvision" style="margin-top:10px;max-width:100%;">'
                                            this.replaceUrl(obj,contents)
                                         }else if(obj.type == 'video_id'){
                                             obj.url = '<video controls="controls" poster="" src='+url+'height="300" style="margin-top:10px;max-width:100%;"></video>'
                                             this.replaceUrl(obj,contents)
                                         }


                                     }
                                 })


                         } catch (err) {


                         }







             },
            async detail(){

                console.log(this.newArr)
                let newStr = ''

                this.newArr.forEach(item=>{
                    newStr += item
                })

                this.companyNoticeList.content = newStr

                this.dialogVisit = true
            },
            changePageClick(){

            },
            handleClose(){

            },
            send(){

                this.$refs["formList"].validate(valid=>{
                    if(!valid){
                        return false
                    }else{
                        this.addNoticeList('send')
                    }
                })
            },
            add(){

                this.$refs["formList"].validate(valid=>{
                    if(!valid){
                        return false
                    }else{
                        this.addNoticeList('add')
                    }
                })

            },
            close(){
                this.dialogVisit = false
            },
            addNoticeList(type){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let arr=[]
                    let img_str = ''
                    let vid_str = ''
                    let newArr = []
                    let newStr = ''
                    arr = this.companyNoticeList.content.split('<').slice(1)


                    // arr.forEach((item,index)=>{
                    //     if(item.indexOf('img') !== -1 && item.indexOf('src') !== -1){
                    //         let obj ={
                    //             picture_id:this.picture_id
                    //         }
                    //         var str = JSON.stringify(obj)
                    //
                    //         img_str = '|&'+str+'|&'
                    //         this.img_index = index
                    //     }else if(item.indexOf('video') !== -1){
                    //         let obj ={
                    //             video_id:this.video_id
                    //         }
                    //         var str = JSON.stringify(obj)
                    //
                    //
                    //         vid_str = '|&'+str+'|&'
                    //         this.vid_index = index
                    //     }
                    //     newArr.push('<'+item)
                    // })

                    //
                    // newArr[this.img_index] = img_str
                    // newArr[this.vid_index] = vid_str

                    // console.log(arr,this.contentList,arr[1].indexOf(this.contentList[0].file_id))

                    for(let i =0;i<arr.length;i++){
                            for(let j =0;j<this.contentList.length;j++){
                                if(arr[i].indexOf(this.contentList[j].file_id) !== -1){
                                    if(this.contentList[j].type == 'image'){
                                        let obj ={
                                            picture_id:this.contentList[j].file_id
                                        }
                                        var str = JSON.stringify(obj)

                                        img_str = '|&'+str+'|&'
                                        arr[i]=img_str
                                        // newArr.push(img_str)
                                    }else if(this.contentList[j].type == 'video'){
                                        let obj ={
                                            video_id:this.contentList[j].file_id
                                        }
                                        var str = JSON.stringify(obj)
                                        vid_str = '|&'+str+'|&'
                                        arr[i]=vid_str
                                        // delete arr[i+1]
                                        // arr.length = arr.length - 1
                                        // newArr.push(vid_str)
                                    }
                                }
                            }

                    }

                    arr.forEach(item=>{
                        if(item.indexOf('picture_id') !== -1 || item.indexOf('video_id') !== -1){
                            newArr.push(item)
                        }else{
                            newArr.push('<'+item)
                        }
                    })



                    newArr.forEach(item=>{
                        newStr += item
                    })
                    let data={
                        tenant_id : user.tenant_id,
                        user_id : user.user_id,
                        title:this.companyNoticeList.title,
                        content:newStr,
                        notice_id:this.notice_id ? this.notice_id : this.uuid,
                        type:type
                    }
                    http.post('/wapi/notice/setNoticeList',data).then(res=>{
                        if(res.success){
                            if(type == 'add'){
                                this.$message({
                                    type:'success',
                                    message:'保存成功'
                                })
                                this.dialogVisit = false
                                this.init()
                            }else{
                                this.$message({
                                    type:'success',
                                    message:'发送成功'
                                })
                                this.dialogVisit = false
                                this.init()
                            }

                        }
                        loading.close()
                    })

                }catch (e) {
                    loading.close()
                    return e
                }
            },
        }
    }
</script>

<style scoped>
    #company >>>.el-form-item__label{
        font-weight: bold;
        color: black;
        text-align: left;
    }
    #company >>> .home_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    #company >>> .el-dialog__header{
        padding: 0;
    }
    #company >>> .company_table_cell{
        color: #2b92fa !important;
    }
    #company >>> .ql-container{
        height: calc(100% - 137px)!important;
    }
    #company >>> .ql-editor{
        height: 600px;
    }
    #company >>> .ql-header{
       width: 80px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/system/components/companyNotice.vue